import clsx from 'clsx';
import { useSectionHeaderStyles } from './SectionHeader.styles';

type SectionHeaderProps = {
  tag: string;
  title: string;
  description: string;
  descriptionVariant?: 'default' | 'brown';
};

const SectionHeader = ({
  tag,
  title,
  description,
  descriptionVariant = 'default',
}: SectionHeaderProps) => {
  const classes = useSectionHeaderStyles();

  return (
    <div className={classes.sectionIntro}>
      <span className={classes.tag}>
        <span className={classes.tagDot} />
        {tag}
      </span>
      <h2 className={classes.sectionTitle}>{title}</h2>
      <p
        className={clsx(
          classes.sectionDescription,
          descriptionVariant === 'brown' && classes.sectionDescriptionBrown,
        )}>
        {description}
      </p>
    </div>
  );
};

export default SectionHeader;
